// import axios from "axios"
import axios from "../customize/axios"

const loginUser = (valueLogin, password)=>{
    try {
        return axios.post("/api/login", {valueLogin, password})
    } catch (error) {
        console.log('Error at loginUser in userServices: ', error)
    }
}

const getDataUser = (user)=>{
    try {
        return axios.get("/api/user/infomation", {user})        
    } catch (error) {
        console.log('Error at getDataUser in userServices: ', error)
    }
}

const updateCurrentUser = (userData)=>{
    try {
        return axios.put('/api/user/updateInfo', {userData})
    } catch (error) {
        console.log('Error at updateCurrentUser in userServices: ', error)       
    }
}

const logoutUser = ()=>{
    try {
        return axios.post('/api/logout')
    } catch (error) {
        console.log('Error at logoutUser in userServices: ', error);
    }
}

const getUserAccount = ()=>{
    try {
        return axios.get(`/api/account`)
    } catch (error) {
        console.log('Error at getUserAccount in userService: ', error)
    }
}


export {
    loginUser, logoutUser, getDataUser, updateCurrentUser, getUserAccount
}